import React from "react";

//@ts-ignore
import styled from "styled-components";

function Preloader(props: { style?: any }) {
  return (
    <Container style={props.style}>
      <div style={{ textAlign: "center" }}>
        <Img src="./rolling.gif" />
      </div>
    </Container>
  );
}

export default Preloader;

export function LoaderWithContent(props: { content: string }) {
  return (
    <ContentContainer>
      <Content>{props.content}.</Content>
      <Preloader style={{ height: "10vh" }} />
    </ContentContainer>
  );
}

const Content = styled.h3`
  font-weight: lighter;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
const Img = styled.img`
  margin: auto;
  width: 60px;
  @media (max-width: 700px) {
    width: 50px;
  }
`;
